import { toast } from "react-toastify"
import reviewAPI from "../../apis/reviewAPI"
import { getReviewsSuccess, requestFail, requestPending } from "./reviewSlice"

export const fetchReviewsAction = () => async (dispatch) => {
  dispatch(requestPending())

  const data = await reviewAPI.fetchReviews()

  data.status === "success"
    ? dispatch(getReviewsSuccess(data.reviews))
    : dispatch(requestFail(data))
}

export const updateReviewAction = (_id, obj) => async (dispatch) => {
  dispatch(requestPending())

  const data = await reviewAPI.updateReview(_id, obj)
  data.status === "success"
    ? dispatch(fetchReviewsAction()) && toast.success(data.message)
    : dispatch(requestFail(data)) && toast.error(data)
}

export const deleteReviewAction = (_id) => async (dispatch) => {
  dispatch(requestPending())
  const data = await reviewAPI.deleteAReview(_id)
  data.status === "success"
    ? dispatch(fetchReviewsAction()) && toast.success(data.message)
    : dispatch(requestFail(data)) && toast.error(data)
}
